import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Typewriter } from 'react-simple-typewriter';
import Lottie from 'lottie-react';
import blog from '../../images/lottie-animation/blog.json';
import './Blog.css'
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import npm from '../../images/blog-image/npm.png'
import npm1 from '../../images/blog-image/npm1.jpeg'
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import { useLanguage } from '../../context/LanguageContext';





const Blog = () => {

    const { language } = useLanguage();



    useEffect(() => {
        AOS.init({
            duration: 3000
        })
    }, [])

    const handleDone = () => {
        console.log(`Done after 5 loops!`)
    }







    return (
        <div id='blog' className='mb-36'>

            {
                language === 'english' ?
                    <h1 id='contact' className='uppercase mt-32 mb-10  text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono'>My <span className='text-rose-600 text-6xl'>Blogs</span>
                        {/* <hr className='mx-auto mt-2 ' width="200px" /> */}
                        <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[280px] md:w-[260px] sm:w-[240px] w-[240px] h-[70px]       wavy'></div>
                    </h1>
                    :
                    <h1 id='contact' className='uppercase mt-32 mb-10  text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono'>আমার <span className='text-rose-600 text-6xl'> ব্লগ </span>
                        {/* <hr className='mx-auto mt-2 ' width="200px" /> */}
                        <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[280px] md:w-[260px] sm:w-[240px] w-[240px] h-[70px]       wavy'></div>
                    </h1>
            }


            {/* <div className='py-6  rounded-2xl w-[320px] sm:w-[320px] md:w-[700px] lg:w-3/4  lg:mx-auto md:mx-auto sm:mx-auto mx-auto glass animation' data-aos='zoom-in'>

                <div className='flex justify-center items-center gap-x-12 lg:flex-row md:flex-col sm:flex-col flex-col'>
                    <div className='w-64' >
                        <Lottie
                            animationData={blog}
                            loop={true}

                        ></Lottie>
                    </div>

                    <h1 className=' text-center text-[26px] sm:text-[24px] md:text-[32px] lg:text-4xl animation' data-aos='fade-left'>
                        <Typewriter
                            words={[
                                'Blogs Coming Soon...',
                                'Stay Connected...'
                            ]}
                            loop={500}
                            cursor
                            cursorStyle='|'
                            typeSpeed={100}
                            deleteSpeed={50}
                            delaySpeed={1000}
                            onLoopDone={handleDone}
                        />
                    </h1>
                </div>

            </div> */}

















            <div className='lg:px-56 md:px-0 px-0'>


                <div className='mt-24 grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 lg:gap-x-12 md:gap-x-6 gap-x-0 md:gap-y-10 gap-y-16 lg:px-10 md:px-4 sm:px-2 px-1 mx-auto animate' data-aos='zoom-in'>



                    <div className="rounded-md card  md:w-[355px] lg:w-[420px] sm:w-[340px] w-[340px] mx-auto bg-base-100 shadow-xl " >
                        <figure><img className='h-56 w-full transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' src={npm} alt="Blogs" /></figure>
                        <div className="card-body">
                            {
                                language === 'english' ?
                                    <h2 className="card-title lg:text-[26px] md:text-[23px] text-[22px] tracking-wide text-white lg:leading-snug leading-tight">7 Most Popular Animation Libraries For React</h2>
                                    :
                                    <h2 className="text-justify card-title lg:text-[22px] md:text-[20px] text-[18px] tracking-wide text-white lg:leading-snug leading-tight">রিঅ্যাক্ট এর জন্য 7টি সর্বাধিক জনপ্রিয় অ্যানিমেশন লাইব্রেরি</h2>
                            }
                            {
                                language === 'english' ?
                                    <>
                                        <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>For a React frontend developer, implementing animations on webpages is an integral part of your daily work...</p>
                                        <p className='text-yellow-600 text-lg font-bold mt-2'>March 5, 2023</p>
                                    </>
                                    :
                                    <>
                                        <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>রিঅ্যাক্ট ফ্রন্টএন্ড ডেভেলপারের জন্য, ওয়েবপেজে অ্যানিমেশন প্রয়োগ করা আপনার দৈনন্দিন কাজের একটি অবিচ্ছেদ্য অংশ...</p>
                                        <p className='text-yellow-600 text-lg font-bold mt-2'>৫ মার্চ, ২০২৩</p>
                                    </>
                            }
                            <Link to='/blog1'>
                                <div className='bg-yellow-600 hover:bg-yellow-700 flex justify-center items-center rounded-md px-4 w-3/4 mt-4 mx-auto' title='View Details'>
                                    {
                                        language === 'english' ?
                                            <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >Read Blog</button>
                                            :
                                            <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >ব্লগ পড়ুন</button>
                                    }
                                    <FiArrowRight className='text-2xl text-white'></FiArrowRight>
                                </div>
                            </Link>
                        </div>
                    </div>


                    <div className="rounded-md card  md:w-[355px] lg:w-[420px] sm:w-[340px] w-[340px] mx-auto bg-base-100 shadow-xl " >
                        <figure><img className='h-56 w-full transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' src={npm1} alt="Blogs" /></figure>
                        <div className="card-body">
                            {
                                language === 'english' ?
                                    <>
                                        <h2 className="card-title lg:text-[26px] md:text-[23px] text-[22px] tracking-wide text-white lg:leading-snug leading-tight">Worst NPM Packages You Should Not Use</h2>
                                        <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>Node Package Manager (npm) is very useful. In this blog We will look into some ridiculous npm packages that should not exist...</p>
                                    </>
                                    :
                                    <>
                                        <h2 className="card-title lg:text-[22px] md:text-[20px] text-[18px] tracking-wide text-white lg:leading-snug leading-tight text-justify">সবচেয়ে খারাপ NPM প্যাকেজ যা আপনার ব্যবহার করা উচিত নয়</h2>
                                        <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>নোড প্যাকেজ ম্যানেজার (এনপিএম) খুব দরকারী। এই ব্লগে আমরা কিছু হাস্যকর এনপিএম প্যাকেজ দেখব যেগুলি থাকা উচিত নয়...</p>
                                    </>
                            }
                            <p className='text-yellow-600 text-lg font-bold mt-2'>এপ্রিল ১৫, ২০২৩</p>
                            <Link to='/blog2'>
                                <div className='bg-yellow-600 hover:bg-yellow-700 flex justify-center items-center rounded-md px-4 w-3/4 mt-4 mx-auto' title='View Details'>

                                    {
                                        language === 'english' ?
                                            <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >Read Blog</button>
                                            :
                                            <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >ব্লগ পড়ুন</button>
                                    }
                                    <FiArrowRight className='text-2xl text-white'></FiArrowRight>
                                </div>
                            </Link>
                        </div>
                    </div>


                    <div className="rounded-md card  md:w-[355px] lg:w-[420px] sm:w-[340px] w-[340px] mx-auto bg-base-100 shadow-xl " >
                        <figure><img className='h-56 w-full transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' src={studyAbroad} alt="Blogs" /></figure>
                        <div className="card-body">
                            {
                                language === 'english' ?
                                    <>
                                        <h2 className="card-title lg:text-[26px] md:text-[23px] text-[22px] tracking-wide text-white lg:leading-snug leading-tight">Why Study Abroad? Stories From International Students</h2>
                                        <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>You might find a degree that isn’t available in your country; you might learn to live independently and learn other cultures...</p>
                                        <p className='text-yellow-600 text-lg font-bold mt-2'>3 May, 2023</p>
                                    </>
                                    :
                                    <>
                                        <h2 className="text-justify card-title lg:text-[22px] md:text-[20px] text-[19px] tracking-wide text-white lg:leading-snug leading-tight">কেন বিদেশে পড়াশুনা করবেন? আন্তর্জাতিক ছাত্রদের থেকে শুনুন</h2>
                                        <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>আপনি একটি ডিগ্রি খুঁজে পেতে পারেন যা আপনার দেশে উপলব্ধ নয়; আপনি স্বাধীনভাবে বাঁচতে এবং অন্যান্য সংস্কৃতি শিখতে পারেন...</p>
                                        <p className='text-yellow-600 text-lg font-bold mt-2'>৩ মে, ২০২৩</p>
                                    </>
                            }

                            <Link to='/blog3'>
                                <div className='bg-yellow-600 hover:bg-yellow-700 flex justify-center items-center rounded-md px-4 w-3/4 mt-4 mx-auto' title='View Details'>

                                    {
                                        language === 'english' ?
                                            <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >Read Blog</button>
                                            :
                                            <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >ব্লগ পড়ুন</button>
                                    }
                                    <FiArrowRight className='text-2xl text-white'></FiArrowRight>
                                </div>
                            </Link>
                        </div>
                    </div>


                </div>


                <Link to='/allBlogs'>
                    <div className='mx-auto text-center mt-24 mb-48 hover:scale-110 transition ease-in-out duration-300 cursor-pointer'>
                        {
                            language === 'english' ?
                                <button className=' text-xl px-16 py-3 bg-gradient-to-r from-violet-900 to-pink-700 rounded-sm text-white'>All Blogs</button>
                                :
                                <button className=' text-xl px-16 py-3 bg-gradient-to-r from-violet-900 to-pink-700 rounded-sm text-white'>সকল ব্লগ</button>
                        }
                    </div>
                </Link>





            </div>




















        </div>
    );
};

export default Blog;